import { Schema } from "@comparaonline/products-schema";

type HasReviews = (product: Schema.ProductListProduct) => boolean;
export const hasReviews: HasReviews = product =>
  Boolean(product.reviews) &&
  Boolean(product!.reviews!.totalByValue) &&
  Boolean(product.reviews!.userReviews) &&
  product!.reviews!.userReviews!.length > 0;
